
export default {
  name: 'SessionExtendModal',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      timer: '02:00',
      seconds: 0,
      intervalId: null
    }
  },
  computed: {
    show: {
      get (): boolean {
        // @ts-ignore
        return this.value
      },
      set (val: boolean) {
        // @ts-ignore
        this.$emit('update:value', val)
      }
    }
  },
  mounted () {
    this.timer = '02:00'
    this.seconds = 0
    this.intervalId = window.setInterval(() => {
      this.seconds += 1
      const remaining = Math.max(0, 120 - this.seconds)
      const mins = Math.floor(remaining / 60)
      const secs = remaining % 60
      this.timer = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`

      if (this.seconds >= 120) {
        if (this.intervalId !== null) {
          clearInterval(this.intervalId)
          this.intervalId = null
        }
        this.seconds = 0
        this.timer = '00:00'
        window.location.href = `${process.env.VUE_APP_V6_URL}/home`
      }
    }, 1000)
  },
  beforeDestroy () {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  },
  methods: {
    onExtend () {
      this.$emit('extend')
    },
    onLogout () {
      this.$emit('logout')
    }
  }
}
